import React from 'react';
import PropTypes from 'prop-types';
import styles from './Modal.module.scss';
import WindowEventWatcher from "../WindowEventWatcher";

const Modal = ({open, children, backdropHandler, closeBtnVisible, ...props}) => {

    if (!open) {
        return null;
    }

    const closeBtn = closeBtnVisible ? <span className={styles.modalCloseBtn}>&times;</span> : null;

    const onKeyDownHandler = e => {
        if (e.code === 'Escape') {
            backdropHandler();
            e.preventDefault();
            e.stopPropagation();
        }
    };

    return (
        <div className={styles.modalBackdrop} onClick={backdropHandler}>
            <WindowEventWatcher eventName={'keydown'} handlerFn={onKeyDownHandler} listening={open}/>
            <div className={styles.modalContainer}>
                {closeBtn}
                {children}
            </div>
        </div>

    );
};

Modal.propTypes = {
    open: PropTypes.bool,
    children: PropTypes.any,
    backdropHandler: PropTypes.func.isRequired,
    closeBtnVisible: PropTypes.bool
};

Modal.defaultProps = {
    open: true,
    children: null,
    backdropHandler: () => null,
    closeBtnVisible: true
};

export default Modal;
